import { z } from 'zod'
import { oc } from '@orpc/contract'

/**
 * Called when a fax is about to be deleted: drops the fax-triage Task id from
 * every board item created from that fax, so their provenance line degrades to
 * plain text instead of linking to a Task that no longer exists.
 *
 * The document id is kept — it is the item's idempotency key and still records
 * which fax the work came from.
 */
export const detachFaxTasks = oc
  .route({ method: 'POST', path: '/v2/fax-tasks/detach' })
  .input(z.object({ documentReferenceId: z.string().min(1) }))
  .output(z.object({ detached: z.number().int().min(0) }))
